import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import InputText from '../components/InputText';
import StyledMessage from './StyledMessage';

export const UserMessageContext = React.createContext({});

const Styled = styled(StyledMessage)``;

class UserMessage extends React.PureComponent {
  static propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    typeInput: PropTypes.bool,
    name: PropTypes.string.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    _error: PropTypes.string,
    disabled: PropTypes.bool,
  };

  state = {
    context: {
      onLinkClick: this.onLinkClick.bind(this),
      disabled: this.props.disabled,
    },
    submitted: false,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.disabled !== this.props.disabled) {
      this.setState({ context: { ...this.state.context, disabled: nextProps.disabled } });
    }
  }

  onLinkClick(value) {
    if (this.props.disabled) {
      return;
    }

    this.props.setFieldValue(this.props.name, value);
    this.setState({ context: { ...this.state.context, activeName: value } });

    if (!this.state.context.activeName) {
      setTimeout(() => this.submit(), 0);
    }
  }

  submit() {
    if (this.props._error !== 'undefined') {
      return;
    }

    this.setState({ submitted: true });
    this.props.onSubmit();
  }

  render() {
    const { typeInput, children, name, value, onChange, _error, disabled } = this.props;

    return (
      <Styled data-answer disabled={disabled}>
        {typeInput ? (
          <React.Fragment>
            {children}
            <InputText
              submitType={'next'}
              onChange={onChange}
              name={name}
              value={value}
              dataTest="brief-text-input"
              onKeyPress={e => e.charCode === 13 && this.submit()}
              onNextClick={() => this.submit()}
              hideNext={this.state.submitted}
              _error={_error}
              disabled={disabled}
              height={35}
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <UserMessageContext.Provider value={this.state.context}>{children}</UserMessageContext.Provider>
            <input type="hidden" name={name} value={value} onChange={onChange} />
          </React.Fragment>
        )}
      </Styled>
    );
  }
}

export default UserMessage;



// WEBPACK FOOTER //
// ./src/scenes/Brief/components/BriefBot/components/UserMessage.js